import { render } from "./Setup-Component.vue?vue&type=template&id=de596c2e"
import script from "./Setup-Component.vue?vue&type=script&lang=js"
export * from "./Setup-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__